import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_a53983a6 from 'nuxt_plugin_sentryserver_a53983a6' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_47a9cca5 from 'nuxt_plugin_sentryclient_47a9cca5' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_libplugin69d19f1f_65c7e10a from 'nuxt_plugin_libplugin69d19f1f_65c7e10a' // Source: ./lib.plugin.69d19f1f.js (mode: 'all')
import nuxt_plugin_axios_09c6f769 from 'nuxt_plugin_axios_09c6f769' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vant_56d10208 from 'nuxt_plugin_vant_56d10208' // Source: ../plugins/vant (mode: 'all')
import nuxt_plugin_elementui_69306e1c from 'nuxt_plugin_elementui_69306e1c' // Source: ../plugins/element-ui (mode: 'all')
import nuxt_plugin_swiper_68e7f06e from 'nuxt_plugin_swiper_68e7f06e' // Source: ../plugins/swiper.js (mode: 'client')
import nuxt_plugin_echarts_49a31ab3 from 'nuxt_plugin_echarts_49a31ab3' // Source: ../plugins/echarts.js (mode: 'client')
import nuxt_plugin_amfeflexible_8520f492 from 'nuxt_plugin_amfeflexible_8520f492' // Source: ../plugins/amfe-flexible (mode: 'client')
import nuxt_plugin_clipboard_106d46e0 from 'nuxt_plugin_clipboard_106d46e0' // Source: ../plugins/clipboard (mode: 'client')
import nuxt_plugin_flyctemp_0286be7b from 'nuxt_plugin_flyctemp_0286be7b' // Source: ../plugins/flyc-temp (mode: 'all')
import nuxt_plugin_vuepictureswipe_684510ee from 'nuxt_plugin_vuepictureswipe_684510ee' // Source: ../plugins/vue-picture-swipe (mode: 'client')
import nuxt_plugin_filter_68021324 from 'nuxt_plugin_filter_68021324' // Source: ../plugins/filter (mode: 'client')
import nuxt_plugin_env_5e4631b7 from 'nuxt_plugin_env_5e4631b7' // Source: ../plugins/env (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, viewport-fit=cover"},{"hid":"description","name":"description","content":"彩宝拥有丰富的彩种开奖，精确的走势图分析，及最专业的预测。北京PK10、时时彩、极速赛车、双色球、大乐透等热门彩种应有尽有!"},{"hid":"keywords","name":"keywords","content":"彩票开奖结果,开奖直播,彩票走势图,彩票稳赚技巧,1彩票赚钱方法,专家预测,竞猜,北京PK10,时时彩,双色球,大乐透,快3,幸运飞艇,香港六合彩,极速赛车"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_a53983a6 === 'function') {
    await nuxt_plugin_sentryserver_a53983a6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_47a9cca5 === 'function') {
    await nuxt_plugin_sentryclient_47a9cca5(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin69d19f1f_65c7e10a === 'function') {
    await nuxt_plugin_libplugin69d19f1f_65c7e10a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_09c6f769 === 'function') {
    await nuxt_plugin_axios_09c6f769(app.context, inject)
  }

  if (typeof nuxt_plugin_vant_56d10208 === 'function') {
    await nuxt_plugin_vant_56d10208(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_69306e1c === 'function') {
    await nuxt_plugin_elementui_69306e1c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_68e7f06e === 'function') {
    await nuxt_plugin_swiper_68e7f06e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_echarts_49a31ab3 === 'function') {
    await nuxt_plugin_echarts_49a31ab3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_amfeflexible_8520f492 === 'function') {
    await nuxt_plugin_amfeflexible_8520f492(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clipboard_106d46e0 === 'function') {
    await nuxt_plugin_clipboard_106d46e0(app.context, inject)
  }

  if (typeof nuxt_plugin_flyctemp_0286be7b === 'function') {
    await nuxt_plugin_flyctemp_0286be7b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuepictureswipe_684510ee === 'function') {
    await nuxt_plugin_vuepictureswipe_684510ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_filter_68021324 === 'function') {
    await nuxt_plugin_filter_68021324(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_env_5e4631b7 === 'function') {
    await nuxt_plugin_env_5e4631b7(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
